import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendIconV4 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.4845 13.5155L19.3633 4.63671M10.6178 13.8582L13.363 20.9173C13.6049 21.5392 13.7258 21.8501 13.9 21.9409C14.051 22.0196 14.231 22.0197 14.3821 21.9412C14.5565 21.8506 14.6777 21.5398 14.9203 20.9182L19.7152 5.36706C19.9342 4.80595 20.0437 4.52539 19.9838 4.34611C19.9318 4.19042 19.8096 4.06824 19.6539 4.01623C19.4746 3.95634 19.1941 4.06583 18.6329 4.2848L3.08177 9.07969C2.46018 9.32226 2.14939 9.44355 2.05881 9.61789C1.9803 9.76902 1.9804 9.94895 2.0591 10.1C2.14987 10.2742 2.46081 10.3951 3.08269 10.637L10.1418 13.3822C10.2681 13.4313 10.3312 13.4558 10.3843 13.4938C10.4314 13.5274 10.4726 13.5686 10.5062 13.6157C10.5442 13.6688 10.5687 13.7319 10.6178 13.8582Z",
		stroke: "#DFCBF5",
		strokeOpacity: .4,
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgSendIconV4;
